import ProjectView from "../project-view"
import ProjectViewAppSettingsLookup from "../../project/inheritance/project-settings"
import {SourceType} from "../../project/inheritance/project-property-lookup"

export default function projectView_getAppSettings(projectView: ProjectView, forceInheritedOnly = false):DictionaryStringAny | null {

    const projectViewAppSettingsLookup = new ProjectViewAppSettingsLookup(projectView.projectViews.project.id)
    const appSettings: any = _.cloneDeep(projectViewAppSettingsLookup.get(projectView.id, forceInheritedOnly))

    switch (projectViewAppSettingsLookup.sourceType) {
        case SourceType.INHERITED:
            appSettings.inheritedFromProjectId = projectViewAppSettingsLookup.sourceProjectId
            break
    }

    return appSettings
}